/* ============================================================
   ASAD ZANZÍBAR — perfume árabe (slug 'asad').
   Producto Shopify "ASAD ZANZIBAR" (8593659330721). 3 combos = 3 variantes
   per-unit: AZ-10 (1 frasco, qty1) · AZ-2 (2 frascos, qty2) · AZ-3 (3, qty3).
   El combo seleccionado fija variante + cantidad; los .cta/sticky disparan
   el modal Releasit COD. unit_price × qty = total del combo, y el pedido
   lleva las unidades reales (Dropi). NO usar _rsiV2.setState como 1er path.
   Ver memory/project_bundles_as_variants + project_asad_landing.
   ============================================================ */
(function () {
  var combos = document.querySelectorAll('.combo');
  var heroPrice = document.getElementById('heroPrice');
  var ctaPrice = document.getElementById('ctaPrice');
  var stickyPrice = document.getElementById('stickyPrice');
  var stickyWas = document.getElementById('stickyWas');
  var stickyName = document.getElementById('stickyName');
  var finalPrice = document.getElementById('finalPrice');
  var fmt = function (n) { return '$' + n.toLocaleString('es-CO'); };

  var selVariant = null;
  var selQty = 1;

  function selectCombo(c) {
    combos.forEach(function (x) { x.classList.remove('sel'); });
    c.classList.add('sel');
    var radio = c.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    var p = +c.dataset.price;
    if (heroPrice) heroPrice.textContent = fmt(p);
    if (ctaPrice) ctaPrice.textContent = fmt(p);
    if (stickyPrice) stickyPrice.textContent = fmt(p);
    if (stickyWas) stickyWas.textContent = fmt(+c.dataset.was);
    if (stickyName) stickyName.textContent = c.dataset.label;
    if (finalPrice) finalPrice.textContent = fmt(p);
    selVariant = c.dataset.bundleVariantId || null;
    selQty = parseInt(c.dataset.bundleQty || '1', 10);
    asadSetVariantOnAllForms(selVariant, selQty);
  }
  combos.forEach(function (c) { c.addEventListener('click', function () { selectCombo(c); }); });

  /* ---------- sincronizar variante + cantidad en el DOM (lo que lee Releasit) ---------- */
  function asadSetVariantOnAllForms(variantId, qty) {
    qty = qty || 1;
    if (variantId) {
      document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) { i.value = variantId; });
      document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    }
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = String(qty); i.setAttribute('value', String(qty)); });
    if (window.productData) { window.productData.quantity = qty; }
    if (variantId && window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* ---------- Releasit COD ---------- */
  var RELEASIT_SELECTORS = ['#rsi_buy_now_button', '.rsi_buy_now_button', '._rsi-buy-now-button', '._rsi-buy-now-button-app-block-hook button', '._rsi-buy-now-button-app-block-hook a', '.rsi-btn-skel'];
  function findReleasit() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) { var el = document.querySelector(RELEASIT_SELECTORS[i]); if (el) return el; }
    return null;
  }
  function asadTriggerCOD() {
    if (!selVariant) {
      var sel = document.querySelector('.combo.sel') || combos[0];
      if (sel) selectCombo(sel);
    }
    asadSetVariantOnAllForms(selVariant, selQty);
    setTimeout(function () {
      var b = findReleasit();
      if (b) { b.click(); return; }
      var n = 0;
      var poll = setInterval(function () {
        n++;
        var bb = findReleasit();
        if (bb) { clearInterval(poll); bb.click(); return; }
        if (n > 30) { clearInterval(poll); if (window._rsiV2 && typeof window._rsiV2.setState === 'function') { try { window._rsiV2.setState({ isOpen: true }); } catch (e) {} } }
      }, 100);
    }, 50);
  }
  window.asadTriggerCOD = asadTriggerCOD;
  document.querySelectorAll('.js-checkout').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); asadTriggerCOD(); });
  });

  /* ---------- galería ---------- */
  var mainImg = document.getElementById('mainImg');
  document.querySelectorAll('.thumbs .t').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.thumbs .t').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (mainImg && t.dataset.img) mainImg.src = t.dataset.img;
    });
  });

  /* ---------- FAQ ---------- */
  document.querySelectorAll('#faq .q button').forEach(function (b) {
    b.addEventListener('click', function () { b.parentElement.classList.toggle('open'); });
  });

  /* ---------- countdown ---------- */
  var t = 23 * 3600 + 59 * 60 + 59;
  var cd = document.getElementById('cd');
  if (cd) setInterval(function () {
    if (t <= 0) t = 23 * 3600 + 59 * 60 + 59;
    t--;
    var h = String(Math.floor(t / 3600)).padStart(2, '0');
    var m = String(Math.floor((t % 3600) / 60)).padStart(2, '0');
    var s = String(t % 60).padStart(2, '0');
    cd.textContent = h + ':' + m + ':' + s;
  }, 1000);

  /* ---------- init: preseleccionar combo marcado ---------- */
  var initial = document.querySelector('.combo.sel') || combos[0];
  if (initial) selectCombo(initial);
})();
